import React from 'react';
import PropTypes from 'prop-types';

const HighSodiumIcon = ({ className, width, height, fill, opacity }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <defs>
      <mask id="hs-mask" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse">
        <rect width="20" height="20" fill="black" />
        <path
          d="M10.13 15.222 4.866 9.958a.5.5 0 0 1-.058-.638l5.411-7.815a1.5 1.5 0 0 1 2.294-.207l6.278 6.277a1.5 1.5 0 0 1-.207 2.294l-7.816 5.411a.5.5 0 0 1-.638-.058ZM3.634 18.393l-1.938-1.937a2.5 2.5 0 0 1-.114-3.415l1.208-1.38a.5.5 0 0 1 .73-.024l4.932 4.933a.5.5 0 0 1-.024.73l-1.38 1.206a2.5 2.5 0 0 1-3.414-.113Z"
          fill="none"
          stroke="white"
          strokeWidth="1.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <path
          d="m3.391 11.707 1.71-1.71 4.99 4.99-1.71 1.71-4.99-4.99Z"
          fill="none"
          stroke="white"
          strokeWidth="1.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </mask>
    </defs>

    <rect
      className="icon"
      x="0"
      y="0"
      width="20"
      height="20"
      fill={fill}
      opacity={opacity}
      mask="url(#hs-mask)"
    />

    <rect className="icon" x="6.137" y="10.499" width="10.47" height="1.2" fill={fill} opacity={opacity} />

    <rect
      className="icon"
      x="4.358"
      y="17.517"
      width="2.278"
      height="1.139"
      rx="0.57"
      transform="rotate(-135 4.358 17.517)"
      fill={fill}
      opacity={opacity}
    />
  </svg>
);

HighSodiumIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  opacity: PropTypes.string,
};

HighSodiumIcon.defaultProps = {
  height: '100%',
  width: '100%',
  fill: 'currentColor',
  opacity: '1',
};

export default HighSodiumIcon;
